module.exports = __webpack_public_path__ + "img/icon-info-circle.22d5a45a.svg";